export default (theme) => ({
  root: {
    padding: theme.spacing(4)
  }
});
